import script from "./Switcher.vue?vue&type=script&setup=true&lang=js"
export * from "./Switcher.vue?vue&type=script&setup=true&lang=js"

import "./Switcher.vue?vue&type=style&index=0&id=5f056c6e&scoped=true&lang=scss"

import exportComponent from "/Users/tom/Sites/thesealcompany.local/app/public/wp-content/themes/the-seal-company/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f056c6e"]])

export default __exports__